/** @jsx jsx */
import React, { useState, useEffect, useRef } from 'react';
import { connectCurrentRefinements, connectRefinementList } from 'react-instantsearch-dom';
import { jsx, Box, Text, Flex } from 'theme-ui';
import Icon from "../Icon";

import { navigate } from 'gatsby';


const selectText = ({ items }) => {

    if (!items.length || items[0]?.currentRefinement.length === 0) {
        if (typeof window !== "undefined")  
            window.expectationsFilter = [];
        return <Text>Select Items</Text>;
    }

    if (typeof window !== "undefined")  
        window.expectationsFilter = items[0].currentRefinement;
    if (items[0].currentRefinement.length === 1) {
        return <Text sx={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            fontFamily: "Open Sans",
        }}>{items[0].currentRefinement[0]}</Text>;
    }
    return <Text sx={{fontFamily: "Open Sans"}}>Selected ({items[0].currentRefinement.length})</Text>;
};
const CustomRefineList = connectCurrentRefinements(selectText);

const RefinementList = ({ items,filterType,viewType, currentRefinement,refine,isFromSearch,searchForItems,createURL,}) => {
    // return the DOM output
    const updateURLWithRefinement = (newRefinedItems) => {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        const label = newRefinedItems.map(obj => obj.label);
        const labelCommaSeparated = label.join(', ');
        urlParams.set('filterType', filterType);
        urlParams.set('viewType', viewType);
        urlParams.set('showFilters', 'true');
        urlParams.set('subFilterValues', `${labelCommaSeparated}`);
    
        url.search = urlParams.toString();
        window.history.pushState(null, '', url.pathname + url.search);
      };
      const [refinedItems, setRefinedItems] = useState([]);

      useEffect(() => {
        setRefinedItems(items.filter((item) => item.isRefined));
      }, [items]);

      const handleCheckboxChange = (event, item) => {
        const newRefinedItems = event.target.checked
          ? [...refinedItems, item]
          : refinedItems.filter((refinedItem) => refinedItem.label !== item.label);
        setRefinedItems(newRefinedItems);
        updateURLWithRefinement(newRefinedItems);
        refine(item.value);
      };
      const sortedItems = items.sort((a, b) => a.label.localeCompare(b.label));
      return (
        <div>
          <ul sx={{ listStyleType: 'none', padding: '0.5rem' }}>
            {sortedItems.map((item) => {
              const isRefined = refinedItems.some(
                (refinedItem) => refinedItem.label === item.label
              );
              return (
                <li key={item.label}>
                  <input
                    type="checkbox"
                    id={`checkbox-${item.label}`}
                    checked={isRefined ? true : false}
                    onClick={(event) => handleCheckboxChange(event, item)}
                  />
                  <label
                    htmlFor={`checkbox-${item.label}`}
                    sx={{ marginLeft: '0.5rem' }}>
                    {item.label} ({item.count})
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      );
  };
  
const CustomRefinementList = connectRefinementList(RefinementList);


const RefList = ({ searchable,filterType,viewType, attribute, onFilterSelectedValue }) => {

    const componentRef = useRef();
    const [dropdown, setDropdown] = useState(false);

    useEffect(() => {
        function handleClick(e) {
            if (componentRef && componentRef.current) {
                const ref = componentRef.current;
                if (!ref.contains(e.target)) {
                    setDropdown(false);
                }
            }
        }
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);

    return (
        <Box sx={{
            zIndex: 1,
            width: "200px",
            minWidth: "200px",
            cursor: "pointer",
        }}
            ref={componentRef}
        >
            <Flex className='drop-head'
                onClick={() => setDropdown(!dropdown)}
                sx={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #D9D9D9",
                    padding: "4px 12px",
                    alignItems: "center",
                    borderRadius: "4px",
                    fontFamily: "Open Sans",
                }}
            >
                <CustomRefineList/>
                <Box sx={{ marginLeft: "auto", pointerEvents: "none" }}>
                    {dropdown ? <Icon icon="md-arrow-up" /> : <Icon icon="md-arrow-down" />}
                </Box>
            </Flex>

            <Box className="ref-list" sx={{
                position: "absolute",
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.04), 0px 8px 40px 8px rgba(0, 0, 0, 0.04)",
                backgroundColor: "#FFFFFF",
                borderRadius: "4px",
                width: "auto",
                minWidth: "inherit",
                display: `${dropdown ? "block" : "none"}`,
                pr: "15px"
            }}>
                <CustomRefinementList limit={200} 
                                attribute={attribute}
                                viewType={viewType}
                                filterType={filterType}
                                searchable={searchable}
                                defaultRefinement={onFilterSelectedValue}/>
            </Box>
        </Box>
    );
};

export default RefList;
